import React, { FC } from 'react';
import DialogContent from '@mui/material/DialogContent';
import styles from './BotInfoDialog.module.css';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { logEvent as logAnalyticsEvent } from '../analytics';
import general from '../resources/general.json';
import { renderAsMarkdown } from '../helpers';
import { getConversationId, getCorrelationId } from '../logging';
import { sanitizeData } from '../dataSanitizeUtils';

export const BotInfoDialog: FC<{
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ isOpen, setIsOpen }) => {
    const handleClose = () => {
        logAnalyticsEvent('Bot Info - Closed', {
            correlation_id: getCorrelationId(),
            conversation_id: getConversationId(),
        });
        setIsOpen(false);
    };

    return (
        <Dialog
            classes={{
                container: styles.dialogContainer,
                root: styles.dialogRoot,
                paper: styles.dialogPaper,
            }}
            onClose={handleClose}
            open={isOpen}
        >
            <DialogContent className={styles.dialogContent}>
                <div className={styles.textContent}>
                    <h3 className={styles.dialogHeader}>
                        {general.providence.botInfoHeader}
                    </h3>
                    <div
                        className={styles.dialogBody}
                        dangerouslySetInnerHTML={{
                            __html: renderAsMarkdown(
                                sanitizeData(general.providence.botInfoBody1)
                            ),
                        }}
                    />
                    <div
                        className={styles.dialogBody}
                        dangerouslySetInnerHTML={{
                            __html: renderAsMarkdown(
                                sanitizeData(general.providence.botInfoBody2)
                            ),
                        }}
                    />
                </div>
                <IconButton
                    className={styles.closeButton}
                    onClick={handleClose}
                    size="large"
                >
                    <CloseIcon />
                </IconButton>
            </DialogContent>
        </Dialog>
    );
};
